<div class="load-registration-overview__container">
    <ax-list-view
        [definitions]="listViewDefinitions"
        [data]="availableTransportVehicleShipments"
        [columnCount]="'auto'"
        (rowClicked)="onItemClick($event)"
    ></ax-list-view>
</div>
